import { ClientSideServiceBuilder } from './client-side-service-builder';
import { setVueEnvContainer } from './vue-env';

/**
 * Build and register the client-side DI container for ViewModels.
 */
export async function registerAllServices(): Promise<void> {
	const container = new ClientSideServiceBuilder().build();
	setVueEnvContainer(container);
}
